import React from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { Button, Dialog, Illustration } from '@node-space/ui-components'
import { useAccountsContext } from 'hooks/context/useAccountsContext'
import { WalletAction } from 'pages/Wallets/components/Modal/WalletModal'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { ApprovalStatuses } from 'types/approvals'

interface RequiresApprovalSuccessModalProps {
  onClose: () => void
  actionType?: WalletAction
}

const RequiresApprovalSuccessModal = ({ onClose }: RequiresApprovalSuccessModalProps) => {
  const { t } = useTranslation()

  const queryClient = useQueryClient()
  const { currentAccount } = useAccountsContext()
  const currentAccountReference = currentAccount?.reference

  const handleOnClose = () => {
    onClose()
    queryClient.invalidateQueries({
      queryKey: reactQueryKeys.approvalsTransactions(
        currentAccountReference,
        ApprovalStatuses.PENDING
      ),
    })
  }

  return (
    <Dialog
      title={t('approvals.sentForApproval')}
      open
      onClose={handleOnClose}
      Illustration={<Illustration name="HourGlassLow" />}
      ActionButtons={[
        <Button key="done" onClick={handleOnClose}>
          {t('done')}
        </Button>,
      ]}
    >
      <p className="text-foreground-prominent text-body-regular text-center">
        {t('approvals.sentForApprovalDisclaimer')}
      </p>
    </Dialog>
  )
}

export default RequiresApprovalSuccessModal
